/**
 * 用户管理的筛选选项、标签颜色（antd 预设色名）和工具函数
 */
export const USER_STATUS_OPTIONS = [
  { value: 'active', label: '活跃' },
  { value: 'inactive', label: '禁用' }
]

// 后端返回英文等级，旧数据可能是中文
const LEVEL_COLORS: Record<string, string> = {
  beginner: 'green',
  intermediate: 'blue',
  advanced: 'orange',
  expert: 'red',
  初级: 'green',
  中级: 'blue',
  高级: 'orange',
  专家: 'red'
}

export function levelColor(level: string) {
  return LEVEL_COLORS[level] ?? 'default'
}

// 去掉易混淆字符（I、O、l、o、0、1）
const RANDOM_CHARSET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789'

// 生成 8 位随机密码（大小写字母和数字），用加密安全的随机数
export function generateRandomPassword(length = 8) {
  const values = crypto.getRandomValues(new Uint32Array(length))
  return Array.from(values, (value) => RANDOM_CHARSET[value % RANDOM_CHARSET.length]).join('')
}
